import request from '@/api/request'



//PC工作台-设置列表
export function approveSetList(data) {
    return request({
        url: '/api/director/approveSet/lists',
        method: 'GET',
        params: data
    })
}

export function approveSetPages(data) {
    return request({
        url: '/api/director/approveSet/pages',
        method: 'GET',
        params: data
    })
}


//PC工作台-设置详情
export function approveSetInfo(data) {
    return request({
        url: '/api/director/approveSet/info',
        method: 'GET',
        params: data
    })
}


//PC工作台-设置打卡修改
export function approveSetEdit(data) {
    return request({
        url: '/api/director/approveSet/edit',
        method: 'POST',
        data
    })
}


//PC工作台-ADD设置
export function approveSetAdd(data) {
    return request({
        url: '/api/director/approveSet/add',
        method: 'POST',
        data
    })
}





//PC工作台-设置删除
export function approveSetDel(data) {
    return request({
        url: '/api/director/approveSet/del',
        method: 'POST',
        data
    })
}


//PC工作台-汇报人列表
export function directorList(data) {
    return request({
        url: '/api/user/directorList',
        method: 'GET',
        params: data
    })
}

//PC工作台-抄送人列表
export function copyList(data) {
    return request({
        url: '/api/user/copyList',
        method: 'GET',
        params: data
    })
}

//PC工作台-控件信息
export function componentsList(data) {
    return request({
        url: '/api/components/lists',
        method: 'GET',
        params: data
    })
}

